<template>
  <div class="page__subtitle">
    4. Соглашение с правилами использования
  </div>
  <div class="check_box__container">
    <v-checkbox
        false-icon="$custom_checkbox"
        class="check__box"
        color="#3254B9"
        v-for="(item, index) in getAgreements"
        :key="`agreement_${index}`"
        @click="checkAgreement(item.id)"
    >
      <template v-slot:label>
        <div class="check__box_text">
          <v-tooltip location="bottom">
            <template v-slot:activator="{ props }">
              <a
                  class="check__box_text link"
                  v-bind="props"
                  :href="getFileLink(item.file.link)"
                  target="_blank"
                  @click.stop
              >
                {{ item.name }}
              </a>
              <span v-if="item.is_obligation" class="text-red"> *</span>
            </template>
            Открыть документ для ознакомления
          </v-tooltip>
        </div>
      </template>
    </v-checkbox>
    <v-checkbox
        false-icon="$custom_checkbox"
        class="check__box"
        color="#3254B9"
        v-model="mails_approve"
        :error="hasError('mails_approve')"
        :error-messages="getError('mails_approve')"
    >
      <template v-slot:label>
        <div class="check__box_text">
          Согласие на рассылку
          <br/>рекламной информации
        </div>
      </template>
    </v-checkbox>
    <div class="alert__container" v-if="error">
      <v-alert
          class="error_alert"
          :value="true"
          outline
          :icon="false"
          color="#8f0808"
          variant="outlined"
      >
        {{ errorText[0] }}
      </v-alert>
    </div>
    <div class="btn__next" @click="clickAcceptAgreements">
      <span class="btn__next_text">
        Завершить регистрацию
      </span>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import helper from "@/urls/helper"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"

export default defineComponent({
  name: "RegistrationApprove",
  mixins: [FormErrorsMixin],
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      getUserStatus: 'auth/getUserStatus',
      getAgreements: 'personal_account/agreements/getAgreements'
    })
  },
  data () {
    return {
      approves: [],
      error: false,
      errorText: null,
      mails_approve: true
    }
  },
  methods: {
    ...mapActions({
      loadAgreements: 'personal_account/agreements/loadAgreements',
      acceptAgreements: 'personal_account/agreements/acceptAgreements',
      changeMailings: 'personal_account/members/changeMailings'
    }),
    getFileLink (url) {
      return helper.getMendeleevUrlWithParameters(url.basename, url.action, url.params, null)
    },
    checkAgreement (agreement) {
      this.error = false
      const index = this.approves.findIndex(item => item === agreement)
      if (index === -1) {
        this.approves.push(agreement)
      } else {
        this.approves.splice(index, 1)
      }
    },
    loadData (url = undefined) {
      this.loadAgreements({
        url: url,
        finalizer: () => {},
        catcher: () => {}
      })
    },
    clickAcceptAgreements () {
      this.acceptAgreements({
        data: { agreement: this.approves },
        finalizer: () => {
          this.clickAcceptMails()
        },
        catcher: (error) => {
          if (error.agreement) {
            this.error = true
            this.errorText = error.agreement
          }
        }
      })
    },
    clickAcceptMails () {
      this.changeMailings({
        data: { is_mailing: this.mails_approve },
        finalizer: () => {
          this.$router.push({ name: pa_names.MAIN })
        },
        catcher: () => {}
      })
    }
  },
  created () {
    if (!this.getUserStatus.agreement) {
      if (this.getUserStatus.special || !this.getUserStatus.member) {
        this.$router.push({ name: pa_names.MAIN })
      }
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.check_box__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 500px;
}

.check__box {
  margin: 0 auto -10px;
  width: 100%;
  color: #313743;
}

.check__box_text {
  padding-left: 30px;
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  display: inline-block;
  align-items: center;
  text-align: left;
  color: #313743;

  &.link {
    padding-left: 0;
    text-decoration-line: underline;
    color: #3254B9;
  }
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-top: 20px;
  margin-bottom: 50px;
  width: 460px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.alert__container {
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  width: 92%;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 21px;
  color: #8f0808;
}

@media screen and (max-width: 1920px) {
  .page__subtitle {
    margin-bottom: 20px;
    font-size: 30px;
    line-height: 41px;
  }

  .check__box {
    margin-bottom: -20px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__subtitle {
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .check_box__container {
    width: 440px;
  }

  .check__box {
    margin-bottom: -20px;
  }

  .btn__next {
    height: 55px;
    margin-bottom: 20px;
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }

  .check__box_text {
    padding-left: 10px;
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .check_box__container {
    width: 300px;
  }
}
</style>
